export default function armarNombreDJIB({impuesto, cuitEmisor, ddjjParams}) {

    const plantilla = impuesto?.plantilla;

    const nameData = {
        cuit: cuitEmisor,
        provincia: impuesto?.descripcion.replaceAll(" ", "_"),
        anio: ddjjParams.anio,
        mes: ddjjParams.mes.toString().padStart(2, "0"),
        lote: "1"
    }

    const fileName = plantilla.replace(/{(\w+)}/g, (match, clave) => {
        return clave in nameData ? nameData[clave] : match;
    });

    return fileName;

}